<template>
  <div>
    <b-card
      class="text-left"
      :title="`Visão geral de: ${workspace.workspace_title}`"
    >
      <!-- Totais de usuario e projetos -->

      <b-row>
        <b-col cols="12" md="8">
          <div class="infos">
            <p>
              Projetos em andamento:
              <strong>{{
                item && item.projectsInProcess
                  ? item.projectsInProcess.length
                  : 0
              }}</strong>
            </p>
            <p>
              Projetos arquivados:
              <strong>{{ item.archivedProjects }}</strong>
            </p>
            <p>
              Usuários ativos: <strong>{{ item.users }}</strong>
            </p>
          </div>
        </b-col>
        <b-col cols="12" md="4">
          <!-- <b-button @click="openPasswordModal"> Abrir Modal </b-button> -->
          <b-button
            @click="$router.push(`/usuarios/dashboard/${member.member_id}`)"
            variant="success"
            class="cta"
          >
            Meu Painel
          </b-button>
          <b-button @click="openModalAction" variant="success" class="cta">
            + Adicionar tarefa
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-card style="overflow-x: auto">
      <div class="mb-2">
        <h4 class="mb-0">Entradas e saídas para a semana</h4>
        <small> {{ weekStartDate }} a {{ weekEndDate }} </small>
      </div>

      <b-row>
        <!-- ENTRADAS -->
        <b-col md="6" class="mb-2">
          <div class="finance-card finance-card--revenue">
            <div class="finance-card__badge">
              <feather-icon icon="DollarSignIcon" size="20" />
              <feather-icon
                icon="TrendingUpIcon"
                size="13"
                class="finance-card__badge-trend"
              />
            </div>

            <span class="finance-card__title">Entradas</span>

            <div class="finance-card__row">
              <span class="finance-card__label">Previsto</span>
              <span class="finance-card__value">{{
                currencyFormatter(weekRevenue.totals.totalPrevisto / 100)
              }}</span>
            </div>

            <div class="finance-card__row">
              <span class="finance-card__label">Realizado</span>
              <span class="finance-card__value">{{
                currencyFormatter(weekRevenue.totals.totalRealizado / 100)
              }}</span>
            </div>

            <div class="finance-card__row finance-card__row--total">
              <span class="finance-card__label">Total</span>
              <span class="finance-card__value">{{
                currencyFormatter(weekRevenue.totals.totalGeral / 100)
              }}</span>
            </div>
          </div>
        </b-col>

        <!-- SAÍDAS -->
        <b-col md="6">
          <div class="finance-card finance-card--expense">
            <div class="finance-card__badge">
              <feather-icon icon="DollarSignIcon" size="20" />
              <feather-icon
                icon="TrendingDownIcon"
                size="13"
                class="finance-card__badge-trend"
              />
            </div>

            <span class="finance-card__title">Saídas</span>

            <div class="finance-card__row">
              <span class="finance-card__label">Previsto</span>
              <span class="finance-card__value">{{
                currencyFormatter(weekExpense.totals.totalPrevisto / 100)
              }}</span>
            </div>

            <div class="finance-card__row">
              <span class="finance-card__label">Realizado</span>
              <span class="finance-card__value">{{
                currencyFormatter(weekExpense.totals.totalRealizado / 100)
              }}</span>
            </div>

            <div class="finance-card__row finance-card__row--total">
              <span class="finance-card__label">Total</span>
              <span class="finance-card__value">{{
                currencyFormatter(weekExpense.totals.totalGeral / 100)
              }}</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Projetos em andamento">
      <b-row class="p-1">
        <b-col cols="12" style="overflow-y: scroll; max-height: 40vh">
          <b-table
            :items="item.projectsInProcess"
            :fields="activeProjectField"
            :sort-compare="sortCompare"
            small
            striped
            show-empty
          >
            <template #empty>
              <b-alert show variant="primary">
                <p class="text-center">
                  <br />
                  Não há
                  <strong>Projetos</strong>
                  em andamento para esta área de trabalho.
                </p>
                <hr />
              </b-alert>
            </template>
            <template v-slot:cell(contract_date)="{ item }">
              <small>
                {{
                  item && item.contract_date
                    ? dateFormatter(item.contract_date)
                    : '-'
                }}</small
              >
            </template>
            <template v-slot:cell(project_name)="{ item }">
              <b-link @click="$router.push(`projetos/dashboard/${item.id}`)">{{
                item.project_name
              }}</b-link>

              <small> ({{ item.project_code }})</small>
            </template>
            <template
              v-slot:cell(stage_predicted_direct_cost_revenue)="{ item, index }"
            >
              R$
              {{
                user.is_admin || user.is_financial
                  ? numberToMonetary(
                      stages_data[index].stage_predicted_direct_cost_revenue,
                    )
                  : '(-)'
              }}
            </template>
            <template v-slot:cell(created_at)="{ item }">
              {{
                item.created_at
                  ? dateFormatter(item.created_at, 'dd/MM/yyyy')
                  : 'indefinido'
              }}
            </template>
            <template v-slot:cell(next_stage_due_date)="{ item, index }">
              {{ dateFormatter(stages_data[index].next_stage_due_date) }}
              <small> ({{ stages_data[index].next_stage_name, }})</small>
            </template>

            <template v-slot:cell(total_expenses)="{ item, index }">
              R$
              {{
                user.is_admin || user.is_financial
                  ? numberToMonetary(stages_data[index].total_expenses)
                  : '(-)'
              }}
            </template>
            <template v-slot:cell(percentual_acml_expenses)="{ item, index }">
              {{ getPercentualExpenses(index) }} %
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
    <div v-if="(user && user.is_transaction_manager) || user.is_admin">
      <b-card title="Filtro">
        <!-- Inputs for date range and toggle button (all in the same row) -->
        <b-row class="align-items-end d-flex">
          <!-- INTERVALO -->
          <b-col md="3">
            <!-- start_date -->
            <b-form-group label="Data de Início">
              <b-form-input v-model="startDate" type="month" />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <!-- end_date -->
            <b-form-group label="Data de Fim">
              <b-form-input v-model="endDate" type="month" />
            </b-form-group>
          </b-col>

          <!-- Botoes  -->
          <b-col sm="6" md="3">
            <b-button
              variant="primary"
              @click="applyDateFilter"
              class="cta"
              block
            >
              Filtrar
            </b-button>
          </b-col>

          <!-- <b-col sm="6" md="3">
          <b-button variant="primary" @click="getAllPeriod" class="cta" block>
            Todo Período
          </b-button>
        </b-col> -->

          <!-- Toggle button -->
          <!-- Empilhado em telas menores -->
          <!-- <b-col sm="12" class="mt-2">
        <b-button variant="primary" @click="toggleDateFiltering" class="cta" block>
          {{ useDateRangeInputs ? 'Intervalo' : 'Mensal' }}
        </b-button>
      </b-col> -->
        </b-row>
      </b-card>

      <b-card title="Painel do escritório" style="overflow-x: auto">
        <b-tabs content-class="mt-3">
          <b-tab title="Cálculos">
            <p></p>
            <b-row class="justify-content-center">
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #9bffc833; border-radius: 5px"
                v-b-tooltip.hover
                title="Somatório de todas as receitas lançadas"
              >
                <p class="text-center mt-1"><b>RECEITAS</b></p>
                <b-card
                  class="text-center"
                  @click="taxesDetail('revenue_detail')"
                  style="cursor: pointer"
                >
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(item.projectRevenue)}`
                  }}</strong>
                  <small style="display: block"
                    >Total de Receitas
                    <feather-icon icon="ExternalLinkIcon" size="12"
                  /></small>
                </b-card>
              </b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
                <h1 class="mt-4 text-center">-</h1>
              </b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #ffc8c833; border-radius: 5px"
                v-b-tooltip.hover
                title="Valores de impostos incididos sobre a receita"
              >
                <p class="text-center mt-1"><b>CUSTOS DIRETOS</b></p>
                <b-card
                  class="text-center"
                  @click="taxesDetail('taxes_detail')"
                  style="cursor: pointer"
                >
                  <strong style="display: block">{{
                    `${numberToMonetary(item.projectRevenueTax)}`
                  }}</strong>
                  <small style="display: block">Despesas Legais </small>
                  <feather-icon icon="ExternalLinkIcon" size="12" />
                </b-card>
              </b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
                <h1 class="mt-4 text-center">=</h1>
              </b-col>

              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #fffdb933; border-radius: 5px"
                v-b-tooltip.hover
                title="Receita - Total despesas do projeto - Custo Direto - Despesas Legais"
              >
                <b-card class="text-center mt-2">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.projectRevenue -
                        (item.projectTotalCost.projectTotalCost -
                          (item.officeTotalCost.totalRealizado +
                            item.costDepreciation +
                            item.team_wages) +
                          item.team_wages +
                          item.projectRevenueTax),
                    )}`
                  }}</strong>
                  <small>
                    {{
                      item.projectRevenue
                        ? `${(
                            ((item.projectRevenue -
                              (item.projectTotalCost.projectTotalCost -
                                (item.officeTotalCost.totalRealizado +
                                  item.costDepreciation +
                                  item.team_wages) +
                                item.team_wages +
                                item.projectRevenueTax)) /
                              item.projectRevenue) *
                            100
                          ).toFixed(2)}%`
                        : '0%'
                    }}</small
                  >
                  <small style="display: block">Margem de Contribuição </small>
                </b-card>
              </b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
                <h1 class="mt-4 text-center">-</h1>
              </b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #d9cfcf33; border-radius: 5px"
              >
                <p class="text-center mt-1"><b>CUSTOS INDIRETOS</b></p>
                <b-card
                  class="text-center"
                  style="cursor: pointer"
                  @click="$router.push('custos-de-escritorio')"
                >
                  <strong style="display: block">{{
                    `${numberToMonetary(item.officeTotalCost.totalRealizado)}`
                  }}</strong>
                  <small style="display: block"
                    >Custos de Escritório Realizados
                    <feather-icon icon="ExternalLinkIcon" size="12"
                  /></small>
                </b-card>
              </b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-col
                cols="12"
                md="2"
                lg="2"
                v-b-tooltip.hover
                title="Receitas deduzidas dos impostos."
              >
                <!-- <b-card class="text-center" style="background-color: #cccccc;" >
                <strong style="display: block">{{
                  `R$ ${numberToMonetary(item.projectRevenueTax)}`
                }}</strong>
                <small style="display: block"><strong>Total de Receita Líquida </strong></small>
              </b-card> -->
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #ffc8c833"
                v-b-tooltip.hover
                title="Somatorio de custos dos colaboradores da equipe técnica"
              >
                <b-card
                  class="text-center mt-1"
                  @click="showTeamWagesTable = true"
                  style="cursor: pointer"
                >
                  <strong style="display: block">{{
                    `${numberToMonetary(item.team_wages)}`
                  }}</strong>
                  <small style="display: block"
                    >Custos da Equipe Técnica
                    <feather-icon icon="ExternalLinkIcon" size="12" />
                  </small>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #d9cfcf33; border-radius: 5px"
              >
                <b-card
                  class="text-center"
                  style="cursor: pointer"
                  @click="$router.push('depreciableAssets')"
                >
                  <strong style="display: block">{{
                    `${numberToMonetary(item.costDepreciation)}`
                  }}</strong>
                  <small style="display: block"
                    >Custos de Depreciação
                    <feather-icon icon="ExternalLinkIcon" size="12"
                  /></small>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="justify-content-center">
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #ffc8c833"
                v-b-tooltip.hover
                title="Somatório de Custos Específicos de Projeto"
              >
                <b-card
                  class="text-center"
                  style="cursor: pointer"
                  @click="$router.push('custos-de-projeto')"
                >
                  <strong style="display: block">{{
                    ` ${numberToMonetary(
                      item.projectTotalCost.projectTotalCost -
                        (item.officeTotalCost.totalRealizado +
                          item.costDepreciation +
                          item.team_wages),
                    )}`
                  }}</strong>
                  <small style="display: block"
                    >Total de Custos de Projetos
                    <feather-icon icon="ExternalLinkIcon" size="12"
                  /></small>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #d9cfcf33"
              ></b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2" style="background: #ffc8c833">
                <h1 class="text-center">=</h1>
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2" style="background: #d9cfcf33">
                <h1 class="text-center">=</h1>
              </b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
              </b-col>
              <b-col cols="12" md="2" lg="2" style="background: #ffc8c833">
                <b-card
                  class="text-center"
                  style="background-color: #cccccc"
                  :class="appMode === 'dark' ? 'bg-dark' : 'bg-light'"
                >
                  <strong style="display: block">{{
                    ` R$ ${numberToMonetary(
                      item.projectTotalCost.projectTotalCost -
                        (item.officeTotalCost.totalRealizado +
                          item.costDepreciation +
                          item.team_wages) +
                        item.team_wages +
                        item.projectRevenueTax,
                    )}`
                  }}</strong>
                  <small
                    style="display: block"
                    :class="appMode === 'dark' ? 'text-light' : 'text-dark'"
                    ><strong>Total de Custos Diretos</strong></small
                  >
                </b-card>
              </b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
                <h1 class="mt-4 text-center">+</h1></b-col
              >
              <b-col cols="12" md="2" lg="2">
                <b-card
                  class="text-center mt-3"
                  style="background-color: #4e4e4e"
                >
                  <strong class="text-white" style="display: block">{{
                    ` R$${numberToMonetary(
                      item.projectTotalCost.projectTotalCost +
                        item.team_wages +
                        item.projectRevenueTax +
                        (item.officeTotalCost.totalRealizado +
                          item.costDepreciation),
                    )}`
                  }}</strong>
                  <small class="text-white" style="display: block"
                    ><strong>Total de Custos</strong></small
                  >
                </b-card>
              </b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
                <h1 class="mt-4 text-center">+</h1></b-col
              >
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="background: #d9cfcf33"
                v-b-tooltip.hover
                title="Despesas Fixas necessárias  ao funcionamento da área de trabalho + Custo total de Bens Depreciados = é o custo que será relacionado ao total de horas computadas para determinação do custo/hora do escritório, este, inversamente proporcional à quantidade de horas computadas pela equipe técnica."
              >
                <b-card
                  class="text-center"
                  style="background-color: #cccccc"
                  :class="appMode === 'dark' ? 'bg-dark' : 'bg-light'"
                >
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.officeTotalCost.totalRealizado +
                        item.costDepreciation,
                    )}`
                  }}</strong>
                  <small style="display: block"
                    ><strong
                      :class="appMode === 'dark' ? 'text-light' : 'text-dark'"
                      >Total de Custo Indireto</strong
                    >
                  </small>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Resultado / Outros custos" active>
            <b-row class="justify-content-center">
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #b89bff33;
                  border: 1px dashed #b89bff;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
                v-b-tooltip.hover
                title="Margem de Contribuição - Custo Indireto (Despesas Fixas)"
              >
                <p class="text-center mt-1"><b>RESULTADO</b></p>
                <b-card class="text-center">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.projectRevenue -
                        (item.projectTotalCost.projectTotalCost +
                          item.team_wages +
                          item.projectRevenueTax) -
                        (item.officeTotalCost.totalRealizado +
                          item.costDepreciation),
                    )}`
                  }}</strong>
                  <small style="display: block">Resultado Operacional</small>
                </b-card>
              </b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
                <h1 class="mt-4 text-center">-</h1>
              </b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #9bffbb33;
                  border: 1px dashed #9bffbb;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
                v-b-tooltip.hover
                title="Somatório das transações de entrada para investimento (transação com nota de descrição)"
              >
                <p class="text-center mt-1"><b>OUTROS CUSTOS</b></p>
                <b-card class="text-center">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.otherCostsCategories[0].total_value,
                    )}`
                  }}</strong>
                  <small style="display: block">Investimentos </small>
                </b-card>
              </b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
                <h1 class="mt-4 text-center">=</h1>
              </b-col>

              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
              >
                <b-card class="text-center mt-2">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.projectRevenue -
                        (item.projectTotalCost.projectTotalCost +
                          item.team_wages +
                          item.projectRevenueTax) -
                        (item.officeTotalCost.totalRealizado +
                          item.costDepreciation) -
                        (item.otherCostsCategories[0].total_value +
                          item.otherCostsCategories[1].total_value +
                          item.otherCostsCategories[2].total_value +
                          item.otherCostsCategories[3].total_value),
                    )}`
                  }}</strong>
                  <small style="display: block">Lucro Líquido </small>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
                v-b-tooltip.hover
                title="ESCRITORIO-N-03: Custo Real do Escritório dividido pelo Total de horas trabalhadas no mês."
              >
                <b-card class="text-center mt-2">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      parseInt(
                        (item.officeTotalCost.totalRealizado +
                          item.costDepreciation) /
                          item.hours,
                      ),
                    )}`
                  }}</strong>
                  <small style="display: block"
                    >Custo Indireto da hora (R$/h)
                  </small>
                </b-card>
              </b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #b89bff33;
                  border: 1px dashed #b89bff;
                  border-top: none;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
              >
                <b-card class="text-center mt-1">
                  <strong style="display: block">
                    {{
                      item.projectRevenue
                        ? `${(
                            ((item.projectRevenue -
                              (item.projectTotalCost.projectTotalCost +
                                item.team_wages +
                                item.projectRevenueTax) -
                              (item.officeTotalCost.totalRealizado +
                                item.costDepreciation)) /
                              item.projectRevenue) *
                            100
                          )
                            .toFixed(3)
                            .replace('.', ',')}%`
                        : '0%'
                    }}
                  </strong>
                  <small style="display: block"
                    >Lucratividade Operacional</small
                  >
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #9bffbb33;
                  border: 1px dashed #9bffbb;
                  border-top: none;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
              >
                <b-card class="text-center mt-1">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.otherCostsCategories[1].total_value,
                    )}`
                  }}</strong>
                  <small style="display: block"
                    >Empréstimos e Financiamento
                  </small>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-bottom: none;
                  border-top: none;
                  border-radius: 5px 5px 0 0;
                "
              >
                <b-card class="text-center mt-2">
                  <strong style="display: block">
                    {{
                      item.projectRevenue > 0 &&
                      item.otherCostsCategories[0] &&
                      item.otherCostsCategories[0].total_value !== 0
                        ? (
                            ((item.projectRevenue -
                              (item.projectTotalCost.projectTotalCost +
                                item.team_wages +
                                item.projectRevenueTax) -
                              (item.officeTotalCost.totalRealizado +
                                item.costDepreciation) -
                              (item.otherCostsCategories[0].total_value +
                                item.otherCostsCategories[1].total_value +
                                item.otherCostsCategories[2].total_value +
                                item.otherCostsCategories[3].total_value)) /
                              item.projectRevenue) *
                            100
                          )
                            .toFixed(2)
                            .replace('.', ',') + '%'
                        : '0%'
                    }}
                  </strong>
                  <small style="display: block">Rentabilidade Final </small>
                </b-card>
              </b-col>

              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-bottom: none;
                  border-top: none;
                  border-radius: 5px 5px 0 0;
                "
              >
                <b-card class="text-center mt-2">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      parseInt(
                        (item.projectTotalCost.totalGeral +
                          (item.projectRevenue - item.projectRevenueTax)) /
                          item.hours,
                      ),
                    )}`
                  }}</strong>
                  <small style="display: block"
                    >Custo direto da hora (R$/h)
                  </small>
                </b-card>
              </b-col>
            </b-row>
            <b-row class="justify-content-center">
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #b89bff33;
                  border: 1px dashed #b89bff;
                  border-top: none;
                  border-radius: 5px 5px 0 0;
                "
              >
                <!-- <b-card class="text-center">
                <strong style="display: block">{{
                  ` ${numberToMonetary(item.projectTotalCost.totalGeral)}`
                }}</strong>
                <small style="display: block">Rentabilidade Operacional</small>
              </b-card> -->
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #9bffbb33;
                  border: 1px dashed #9bffbb;
                  border-top: none;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
              >
                <b-card class="text-center">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.otherCostsCategories[2].total_value,
                    )}`
                  }}</strong>
                  <small style="display: block">Distribuição de Lucros</small>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-bottom: none;
                  border-top: none;
                  border-radius: 5px 5px 0 0;
                "
                v-b-tooltip.hover
                title="Somatório de total de custos diretos e indiretos relativos às horas computadas pela equipe técnica"
              >
                <b-card class="text-center mt-2">
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.officeTotalCost.totalRealizado +
                        item.costDepreciation +
                        item.team_wages,
                    )}`
                  }}</strong>
                  <small style="display: block">Custo Total (Tarefas) </small>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-top: none;
                  border-radius: 5px 5px 0 0;
                "
                v-b-tooltip.hover
                title="Esse custo se refere ao valor específico de cada mês. No painel POR PERÍODO o custo deve ser representado através do cálculodo custo médio de horas diretas e indiretas."
              >
                <b-card
                  class="text-center mt-2"
                  style="background-color: #cccccc"
                  :class="appMode === 'dark' ? 'bg-dark' : 'bg-light'"
                >
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      parseInt(
                        (item.officeTotalCost.totalRealizado +
                          item.costDepreciation) /
                          item.hours +
                          (item.projectTotalCost.totalGeral +
                            (item.projectRevenue - item.projectRevenueTax)) /
                            item.hours,
                      ),
                    )}`
                  }}</strong>
                  <small style="display: block"
                    ><strong
                      :class="appMode === 'dark' ? 'text-light' : 'text-dark'"
                      >Custo Total da Hora no Mês (R$/h)</strong
                    >
                  </small>
                </b-card>
              </b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #9bffbb33;
                  border: 1px dashed #9bffbb;
                  border-top: none;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
              >
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-bottom: none;
                  border-top: none;
                  border-radius: 5px 5px 0 0;
                "
              ></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2"> </b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #9bffbb33;
                  border: 1px dashed #9bffbb;
                  border-top: none !important;
                  border-bottom: none !important;

                  border-radius: 5px 5px 0 0;
                "
                v-b-tooltip.hover
                :title="
                  (item.otherCostsCategories[3].categories || []).join(', ')
                "
              >
                <b-card
                  class="text-center"
                  style="background-color: #ffffff !important"
                  :class="appMode === 'dark' ? 'bg-dark' : 'bg-light'"
                >
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.otherCostsCategories[3].total_value,
                    )}`
                  }}</strong>
                  <small
                    style="display: block"
                    :class="appMode === 'dark' ? 'text-light' : 'text-dark'"
                  >
                    Não classificados
                  </small>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-top: none;
                  border-bottom: none;
                  border-radius: 5px 5px 0 0;
                "
                v-b-tooltip.hover
                title="Receita necessária para igualar os gastos"
              >
                <!-- <b-card class="text-center mt-2">
                  <strong style="display: block">{{
                    item.projectRevenue
                      ? `R$ ${numberToMonetary(
                          ((item.officeTotalCost.totalRealizado +
                            item.costDepreciation) /
                            (((item.projectRevenue -
                              (item.projectTotalCost.totalGeral +
                                (item.projectRevenue -
                                  item.projectRevenueTax))) /
                              item.projectRevenue) *
                              100)) *
                            100,
                        )}`
                      : 'R$ 0.00'
                  }}</strong>
                  <small style="display: block">Ponto de Equiliibrio </small>
                </b-card>
                -->
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2"></b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #9bffbb33;
                  border: 1px dashed #9bffbb;
                  border-bottom: none !important;
                  border-top: none !important;
                  border-radius: 5px 5px 0 0;
                "
              >
                <h1 class="text-center">=</h1>
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-bottom: none;
                  border-top: none;
                  border-radius: 5px 5px 0 0;
                "
              ></b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2"></b-col>
            </b-row>

            <b-row class="justify-content-center">
              <b-col cols="12" md="2" lg="2"></b-col>
              <b-col cols="12" md="1" lg="1" style="max-width: 50px !important">
              </b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #9bffbb33;
                  border: 1px dashed #9bffbb;
                  border-top: none !important;
                  border-radius: 5px 5px 0 0;
                "
              >
                <b-card
                  class="text-center"
                  style="background-color: #cccccc"
                  :class="appMode === 'dark' ? 'bg-dark' : 'bg-light'"
                >
                  <strong style="display: block">{{
                    `R$ ${numberToMonetary(
                      item.otherCostsCategories[0].total_value +
                        item.otherCostsCategories[1].total_value +
                        item.otherCostsCategories[2].total_value +
                        item.otherCostsCategories[3].total_value,
                    )}`
                  }}</strong>
                  <small style="display: block"
                    ><strong
                      :class="appMode === 'dark' ? 'text-light' : 'text-dark'"
                      >Total de Outros Custos</strong
                    ></small
                  >
                </b-card>
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col
                cols="12"
                md="2"
                lg="2"
                style="
                  background: #fffdb933;
                  border: 1px dashed #b7aa00;
                  border-top: none !important;
                  border-radius: 5px 5px 0 0;
                "
                v-b-tooltip.hover
                title="Receita necessária para igualar os gastos"
              >
              </b-col>
              <b-col
                cols="12"
                md="1"
                lg="1"
                style="max-width: 50px !important"
              ></b-col>
              <b-col cols="12" md="2" lg="2"></b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-card>

      <!-- <b-card>
    
      <b-col cols="12">
        <b-row class="d-flex justify-content-around">
          <div class="dashboard-item text-center">
            <strong>{{ ` ${numberToMonetary(item.projectCosts)}` }}</strong>
            <small>Total de despesas de projeto </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ ` ${numberToMonetary(item.legalExpenses)}` }}</strong>
            <small>Total de despesas legais (impostos) </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ `${numberToMonetary(item.projectRevenue)}` }}</strong>
            <small>Total de receitas </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ `${numberToMonetary(item.team_wages)}` }}</strong>
            <small>Custo Direto </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ ` ${numberToMonetary(item.inteam_wages)}` }}</strong>
            <small>despesa fixa </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{
              `${numberToMonetary(item.projectTasksTotalCost)}`
            }}</strong>
            <small>Custo Total (tarefas) </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ `${numberToMonetary(item.projectTotalCost)}` }}</strong>
            <small>Custo Total (projetos) </small>
          </div>

          
          <div class="dashboard-item text-center">
            <strong>{{
              ` ${numberToMonetary(item.contributionMargin)}`
            }}</strong>
            <small>Margem de contribuição </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ `${numberToMonetary(item.officeTotalCost.totalRealizado)}` }}</strong>
            <small>Custo total de escritório </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ `${numberToMonetary(item.costDepreciation)}` }}</strong>
            <small>Custo de depreciação </small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ `${numberToMonetary(item.realCostOffice)}` }}</strong>
            <small>Custo real</small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{
              `${
                (item.officeTotalCost.totalRealizado > 0 && item.hours > 0) ||
                item.costDepreciation > 0
                  ? numberToMonetary(
                      item.officeTotalCost.totalRealizado / item.hours + item.costDepreciation
                    )
                  : '0'
              }`
            }}</strong>
            <small>Custo real da hora</small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{ `${item.hours}h` }}</strong>
            <small>Total de horas trabalhadas</small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{
              `${item.profitability > 0 ? item.profitability : 0}%`
            }}</strong>
            <small>Lucratividade</small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{
              `${
                item.economicBreakEvenPoint > 0
                  ? numberToMonetary(item.economicBreakEvenPoint)
                  : '(Margem negativa)'
              }`
            }}</strong>
            <small>Ponto de equilíbrio financeiro (receita bruta mínima)</small>
          </div>

          <div class="dashboard-item text-center">
            <strong>{{
              `${
                signalNumber(item.projectResult) == false ? '-' : ''
              } ${numberToMonetary(
                signalNumber(item.projectResult) == false
                  ? item.projectResult * -1
                  : item.projectResult
              )}`
            }}</strong>
            <small>Resultado</small>
          </div>
        </b-row>
      </b-col>

    </b-card> -->

      <!-- DASHBOARDS -->

      <b-card
        v-if="hoursPerEmployee_data.render"
        class="overflow-scroll-mobile"
      >
        <b-row>
          <b-col
            :lg="costPerProject_data.chartSeries[0].data.length < 5 ? 6 : 12"
            :md="costPerProject_data.chartSeries[0].data.length < 5 ? 6 : 12"
            class="text-center mx-auto w-10 h-50 mb-2"
          >
            <label>Horas por colaborador</label><br />
            <label>{{ `${item.hours}h 00m` }}</label>
            <ProfitabilityChart :chartData="hoursPerEmployee_data"
          /></b-col>
          <b-col
            :lg="costPerProject_data.chartSeries[0].data.length < 5 ? 6 : 12"
            :md="costPerProject_data.chartSeries[0].data.length < 5 ? 6 : 12"
            class="text-center mx-auto w-10 h-50"
          >
            <label>Custo por projeto</label>
            <ProfitabilityChart :chartData="costPerProject_data"
          /></b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            class="text-center mx-auto flex"
            :md="costsPerMember_data.chartSeries[0].data.length < 5 ? 6 : 12"
          >
            <label>Custo Direto + Indireto por colaborador</label>
            <ProfitabilityChart
              v-if="costsPerMember_data.render"
              :chartData="costsPerMember_data"
          /></b-col>
        </b-row>
      </b-card>

      <b-card class="overflow-scroll-mobile" title="Fluxo financeiro">
        <b-col class="text-center mx-auto w-10 h-50">
          <label></label>
          <CashFlow type="line" height="400" :chartData="cashFlow_data" />
        </b-col>
      </b-card>

      <!-- <b-card v-if="costPerOffice_data.render" class="overflow-scroll-mobile">
        <b-col class="text-center mx-auto w-10 h-50">
          <label>Custo por ano</label>
          <ProfitabilityChart :chartData="costPerOffice_data"
        /></b-col>
      </b-card> -->

      <b-modal
        v-model="showTeamWagesTable"
        title="Custos da equipe técnica"
        centered
        size="lg"
        hide-footer
      >
        <b-table responsive :items="teamWageTable" :fields="team_wage_fields">
          <template v-slot:cell(month_payment)="{ item }">
            {{ currencyFormatter(item.month_payment / 100) }}
          </template>
          <template v-slot:cell(created_at)="{ item }">
            {{ item.month }} / {{ item.year }}
          </template>
        </b-table>
      </b-modal>
      <b-modal
        v-model="taxesDetailModal"
        title="Detalhamento de receitas"
        centered
        hide-footer
        size="xl"
      >
        <b-table
          responsive
          :items="revenueDetailTable"
          :fields="revenue_detail_fields"
        >
          <template v-slot:cell(status)="{ item }">
            {{ item && item.status ? item.status.toUpperCase() : '-' }}
          </template>
          <template v-slot:cell(projectRevenue)="{ item }">
            {{ currencyFormatter(item.projectRevenue / 100) }}
          </template>
          <template v-slot:cell(value)="{ item }">
            {{ currencyFormatter(item.value / 100) }}
          </template>
          <template v-slot:cell(reference_date)="{ item }">
            {{ dateFormatter(item.reference_date) }}
          </template>
          <template v-slot:cell(transaction_date)="{ item }">
            {{ dateFormatter(item.transaction_date) }}
          </template>
          <template v-slot:cell(projectRevenueTax)="{ item }">
            {{ currencyFormatter(item.projectRevenueTax / 100) }}
          </template>
          <template v-slot:cell(difference)="{ item }">
            {{
              item.projectRevenueTax == 0
                ? 'R$ 0,00'
                : item && item.expense && item.expense.value
                ? currencyFormatter(item.expense.value / 100)
                : 'R$ 0,00'
            }}
          </template>
        </b-table>
        <div class="mr-2 d-flex flex-column align-items-end">
          <strong>Total de registros: {{ revenueDetailTable.length }}</strong>
          <strong
            >Total previsto: R$
            {{
              totalExpandedRevenues
                ? numberToMonetary(totalExpandedRevenues.totalPrevisto)
                : 0
            }}</strong
          >
          <strong
            >Total realizado: R$
            {{
              totalExpandedRevenues
                ? numberToMonetary(totalExpandedRevenues.totalRealizado)
                : 0
            }}</strong
          >
          <strong
            >Impostos: R$
            {{
              item.projectRevenueTax
                ? numberToMonetary(item.projectRevenueTax)
                : 0
            }}
          </strong>
          <hr />
          <strong
            >Saldo: R$
            {{
              totalExpandedRevenues
                ? numberToMonetary(totalExpandedRevenues.totalGeral)
                : 0
            }}</strong
          >
        </div>
      </b-modal>
      <two-step-modal
        @confirmPassModal="confirmPassModal"
        :passModal="passModal"
      />
    </div>
    <div>
      <Modal
        @closeModal="closeModal"
        :open="myTasksModal"
        :costs_variables="costs_variables"
      />
    </div>
  </div>
</template>

<script>
import {
  VBTooltip,
  BCol,
  BRow,
  BCard,
  BFormGroup,
  BButton,
  BFormInput,
  BTab,
  BTabs,
  BAlert,
  BTable,
  BLink,
} from 'bootstrap-vue';
import ProfitabilityChart from '@/components/Chart.vue';
import CashFlow from '@/components/CashFlow.vue';
import Modal from '@/views/pages/manager/myTasks/Modal.vue';
import moment from 'moment';
import TwoStepModal from '@/components/TwoStepModal.vue';

//import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCol,
    BRow,
    BCard,
    ProfitabilityChart,
    CashFlow,
    BFormGroup,
    BButton,
    BFormInput,
    Modal,
    BTab,
    BTabs,
    BAlert,
    BTable,
    BLink,
    TwoStepModal,
  },
  data: () => ({
    weekRevenue: {
      totals: {
        totalGeral: 0,
        totalPrevisto: 0,
        totalRealizado: 0,
      },
      data: [],
    },
    weekExpense: {
      totals: {
        totalGeral: 0,
        totalPrevisto: 0,
        totalRealizado: 0,
      },
      transactions: [],
    },
    passModal: false,
    showTeamWagesTable: false,
    taxesDetailModal: false,
    stages_data: [],
    teamWageTable: [],
    revenueDetailTable: [],
    totalExpandedRevenues: {},
    costs_variables: {
      average_office_cost: '',
      hour_per_month: '',
    },
    costsPerMember_data: { render: false },
    hoursPerMember_dataProps: '',

    item: {
      projectCosts: 0,
      legalExpenses: 0,
      projectRevenue: 0,
      team_wages: 0,
      team_wage_details: [],
      inteam_wages: 0,
      projectTasksTotalCost: 0,
      projectTotalCost: 0,
      contributionMargin: 0,
      officeTotalCost: 0,
      costDepreciation: 0,
      realCostOffice: 0,
      realCostHour: 0,
      hours: 0,
      profitability: 0,
      economicBreakEvenPoint: 0,
      projectResult: 0,
      projectsInProcess: 0,
      archivedProjects: 0,
      users: 0,
    },

    member: {},
    selectedMonth: 'Janeiro',
    selectedYear: 2024,
    months: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    years: [2020, 2021, 2022, 2023, 2024, 2025],
    activeProjectField: [
      {
        key: 'project_name',
        label: 'Nome',
        sortable: true,
      },
      {
        key: 'project_code',
        label: 'Codigo',
        sortable: false,
      },
      {
        key: 'created_at',
        label: 'Criado em',
        sortable: false,
      },
      {
        key: 'contact_name',
        label: 'nome do contato',
        sortable: false,
      },
      {
        key: 'contact_phone',
        label: 'telefone do contato',
        sortable: true,
      },
      {
        key: 'contract_date',
        label: 'Data do contrato',
        sortable: true,
      },
      {
        key: 'stage_predicted_direct_cost_revenue',
        label: 'Previsão de receita',
        sortable: false,
      },
      {
        key: 'next_stage_due_date',
        label: 'Deadline da próxima fase',
        sortable: false,
      },
      {
        key: 'total_expenses',
        label: 'Despesas acumuladas',
        sortable: false,
      },
      {
        key: 'percentual_acml_expenses',
        label: 'Percentual de despesas acumuladas',
        sortable: false,
      },
    ],
    team_wage_fields: [
      {
        key: 'member.access.user.username',
        label: 'Nome',
        sortable: true,
      },
      {
        key: 'month_payment',
        label: 'Valor',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Referência',
        sortable: true,
      },
    ],
    revenue_detail_fields: [],
    totalRevenueTaxes: 0,
    useDateRangeInputs: false,
    startDate: '',
    endDate: '',
    originalHoursEmployeeProps: '',
    originalProjectCostProps: '',
    originalCashFlowProps: '',
    originalCostPerOfficeProps: '',
    dispatch_start_date: '',
    dispatch_end_date: '',
    project_name: 'Projeto',
    workspace: { workspace_title: '' },
    myTasksModal: false,
    hoursPerEmployee_data: { render: false },
    costPerProject_data: { render: false },
    costPerOffice_data: { render: false },
    cashFlow_data: { render: false },
    cashFlowResp: [],
    firstCashFlowCall: true,
  }),

  created() {
    this.getCurrentMonth();
    this.getPastYearOfficeCost();
    this.updateDates();
    this.getItem();
    //this.getCashFlow();
    this.getMemberInfo();
    this.getTasksCosts();
    this.getWeekRevenue();
    this.getWeekExpense();
  },
  watch: {
    appMode(newMode) {
      this.setHoursPerEmployee_data(this.originalHoursEmployeeProps);
      this.setCostPerProject_data(this.originalProjectCostProps);
      this.setCashFlow_data(newMode);
      this.setcostPerOffice_data(this.originalCostPerOfficeProps);
    },
  },

  computed: {
    currentWorkspace() {
      return this.$store.getters.currentWorkspace;
    },
    appMode() {
      return this.$store.state.appConfig.layout.skin;
    },
    user() {
      return this.$store.getters.user.accesses.find(
        (a) => a.workspace_id == this.currentWorkspace.id,
      );
    },

    getPercentualExpenses() {
      return (index) => {
        const total = Number(this.stages_data[index]?.total_expenses) || 0;
        const predicted =
          Number(
            this.stages_data[index]?.stage_predicted_direct_cost_revenue,
          ) || 0;

        if (!predicted || predicted === 0) {
          return '0.00';
        }

        const result = (total / predicted) * 100;

        if (!isFinite(result)) {
          return '0.00';
        }

        return result.toFixed(2);
      };
    },
    weekStartDate() {
      return moment().startOf('week').format('DD/MM/YYYY');
    },

    weekEndDate() {
      return moment().endOf('week').format('DD/MM/YYYY');
    },
  },

  methods: {
    taxesDetail(val) {
      this.revenue_detail_fields = [];
      if (val == 'revenue_detail') {
        this.taxesDetailModal = true;
        this.revenue_detail_fields = [
          {
            key: 'transaction_group',
            label: 'Grupo de transação',
            sortable: false,
          },
          {
            key: 'projectRevenue',
            label: 'Valor da receita bruta',
            sortable: false,
          },
          {
            key: 'projectRevenueTax',
            label: 'Valor da receita liquida',
            sortable: false,
          },
          {
            key: 'value',
            label: 'Valor da Parcela',
            sortable: false,
          },
          {
            key: 'difference',
            label: 'Impostos',
            sortable: false,
          },
          {
            key: 'project_name',
            label: 'Projeto',
            sortable: true,
          },
          {
            key: 'status',
            label: 'Status',
            sortable: true,
          },
          {
            key: 'transaction_date',
            label: 'Data transação',
            sortable: true,
          },
          {
            key: 'reference_date',
            label: 'Data referência',
            sortable: true,
          },
        ];
      } else {
        this.taxesDetailModal = true;
        this.revenue_detail_fields = [
          {
            key: 'projectRevenue',
            label: 'Valor da receita bruta',
            sortable: false,
          },
          {
            key: 'difference',
            label: 'Impostos',
            sortable: false,
          },
          {
            key: 'project_name',
            label: 'Projeto',
            sortable: true,
          },
          {
            key: 'transaction_date',
            label: 'Data transação',
            sortable: true,
          },
          {
            key: 'reference_date',
            label: 'Data referência',
            sortable: true,
          },
        ];
      }
    },
    getWeekRevenue() {
      const params = {
        workspace_id: this.currentWorkspace.id,
        perPage: 100000,
        page: 1,
      };
      this.$store
        .dispatch('weekRevenue', this.formatQueryParams(params))
        .then((resp) => {
          if (resp?.totals) {
            this.weekRevenue = {
              totals: resp.totals,
              data: resp.data,
            };
          }
        });
    },
    getWeekExpense() {
      const params = {
        workspace_id: this.currentWorkspace.id,
        perPage: 100000,
        page: 1,
      };
      this.$store
        .dispatch('weekExpense', this.formatQueryParams(params))
        .then((resp) => {
          if (resp?.totals) {
            this.weekExpense = {
              totals: resp.totals,
              transactions: resp.transactions,
            };
          }
        });
    },
    sortCompare(aRow, bRow, key) {
      if (key === 'project_code') {
        return String(aRow.project_code || '').localeCompare(
          String(bRow.project_code || ''),
          undefined,
          {
            numeric: true,
            sensitivity: 'base',
          },
        );
      }

      return null; // deixa o BootstrapVue usar a comparação padrão
    },
    confirmPassModal(val) {
      this.passModal = val;
    },
    openPasswordModal() {
      this.passModal = true;
    },
    getClosestStage(stages) {
      if (!Array.isArray(stages) || stages.length === 0) {
        return { stage_name: '-', stage_due_date: '-' };
      }

      const today = new Date();

      const stagesWithDate = stages.filter(
        (s) => s.stage_due_date && !isNaN(new Date(s.stage_due_date).getTime()),
      );

      if (stagesWithDate.length === 0) {
        return { stage_name: '-', stage_due_date: '-' };
      }

      const closest = stagesWithDate.sort((a, b) => {
        const diffA = Math.abs(new Date(a.stage_due_date) - today);
        const diffB = Math.abs(new Date(b.stage_due_date) - today);
        return diffA - diffB;
      })[0];

      return {
        stage_name: closest.stage_name,
        stage_due_date: closest.stage_due_date,
      };
    },
    async getPastYearOfficeCost() {
      this.$store
        .dispatch('getPastYearOfficeCost', {
          workspace_id: this.$store.getters.currentWorkspace.id,
          group: 'offices',
          expense: true,
        })
        .then((resp) => {
          this.costs_variables.average_office_cost = resp.averageValue;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getCashFlow() {
      this.cashFlowResp = [];

      let start = this.dispatch_start_date;
      let end = this.dispatch_end_date;

      if (this.firstCashFlowCall) {
        start = moment(start).subtract(6, 'months').format('YYYY-MM-DD');
        end = moment(end).add(6, 'months').format('YYYY-MM-DD');

        this.firstCashFlowCall = false;
      }

      this.$store
        .dispatch('getCashFlowDashboard', {
          workspace_id: this.$store.getters.currentWorkspace.id,
          start_date: start,
          end_date: end,
        })
        .then((resp) => {
          this.cashFlowResp = resp;
          this.setCashFlow_data();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getItem() {
      this.$store
        .dispatch('getWorkspace', {
          id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          this.workspace = resp;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCurrentMonth() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth()).padStart(2, '0');
      this.startDate = `${year}-${month}`;
      this.endDate = `${year}-${month}`;

      this.dispatch_start_date = `${year}-${month}`;
      this.dispatch_end_date = `${year}-${month}`;
    },

    async getMemberInfo() {
      this.$store
        .dispatch('getUserMember', {
          id: this.$store.getters.user.id,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          this.member = resp[0];
          this.costs_variables.hour_per_month =
            resp[0] && resp[0].member ? resp[0].member.hour_per_month : 0;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getAll() {
      this.item = {};
      this.$store
        .dispatch('getDashboard', {
          start_date: this.dispatch_start_date,
          end_date: this.dispatch_end_date,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then(async (resp) => {
          this.item = {
            ...resp.resumeDashboard,
          };
          if (resp?.resumeDashboard?.projectRevenueDetails) {
            this.item.projectRevenue =
              resp.resumeDashboard.projectRevenueDetails.reduce(
                (total, item) =>
                  total + Number(item.value || item.projectRevenue || 0),
                0,
              );
          }

          if (resp?.resumeDashboard?.projectRevenueDetails) {
            console.log('this.rsp', resp.resumeDashboard.projectRevenueDetails);

            this.item.projectRevenueTax =
              resp.resumeDashboard.projectRevenueDetails.reduce(
                (total, item) => {
                  return total + Number(item.expense?.value || 0);
                },
                0,
              );
          }

          if (resp?.resumeDashboard?.team_wage_details) {
            this.teamWageTable = resp?.resumeDashboard?.team_wage_details || [];
          }

          if (resp?.resumeDashboard?.totalExpandedRevenues) {
            this.totalExpandedRevenues =
              resp.resumeDashboard.totalExpandedRevenues || {};
          }

          if (resp?.resumeDashboard?.projectRevenueDetails) {
            this.revenueDetailTable =
              resp?.resumeDashboard?.projectRevenueDetails || [];
          }

          if (resp?.resumeDashboard?.projectsInProcess) {
            this.stages_data = resp.resumeDashboard.projectsInProcess.map(
              (item) => {
                const stages = Array.isArray(item.project_stages)
                  ? item.project_stages
                  : [];

                // Soma os valores de cada stage
                const totalContractRevenue = stages.reduce(
                  (sum, stage) =>
                    sum + (stage.stage_predicted_contract_revenue || 0),
                  0,
                );

                const totalDirectCostRevenue = stages.reduce(
                  (sum, stage) =>
                    sum + (stage.stage_predicted_direct_cost_revenue || 0),
                  0,
                );

                const closestStage = this.getClosestStage(stages);

                //ACUMULA DESPESAS DE PROJETO
                const expenses = Array.isArray(item.expenses)
                  ? item.expenses
                  : [];

                const totalExpenses = expenses.reduce(
                  (sum, expense) => sum + (expense.value || 0),
                  0,
                );

                return {
                  project_id: item.id,
                  project_name: item.project_name,
                  stage_predicted_contract_revenue: totalContractRevenue,
                  stage_predicted_direct_cost_revenue: totalDirectCostRevenue,
                  next_stage_name: closestStage.stage_name,
                  next_stage_due_date: closestStage.stage_due_date,
                  total_expenses: totalExpenses,
                };
              },
            );
          }

          this.setHoursPerEmployee_data(resp.employeeHours);
          this.setCostPerProject_data(resp.projectsCosts);
          this.setcostPerOffice_data(resp.OfficeTransactionsByYear);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getTasksCosts() {
      let body = {
        start_date: this.dispatch_start_date,
        end_date: this.dispatch_end_date,
        workspace_id: this.$store.getters.currentWorkspace.id,
      };

      let queryParams = this.formatQueryParams(body);
      this.$store
        .dispatch('getProjectDashboard', queryParams)
        .then(async (resp) => {
          await this.setCostPerMemberChart(resp.tasksCostAndHours);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getAllPeriod() {
      const anoAtual = new Date().getFullYear();
      const startDate = new Date(anoAtual, 0, 1);
      const formattedStartDate = startDate.toISOString().split('T')[0];

      const endDate = new Date(anoAtual, 11, 31);
      const formattedEndDate = endDate.toISOString().split('T')[0];

      this.dispatch_start_date = formattedStartDate;
      this.dispatch_end_date = formattedEndDate;

      this.$toast.success('Selecionado todo o periodo.', {
        position: 'top-right',
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: 'button',
        icon: true,
        rtl: false,
      });

      await this.getAll();
    },

    async updateDates() {
      const startDateWithDay = `${this.startDate}-01`;
      const endDateYear = parseInt(this.endDate.substring(0, 4));
      const endDateMonth = parseInt(this.endDate.substring(5, 7));

      const lastDayOfMonth = new Date(endDateYear, endDateMonth, 0).getDate();

      const formattedMonth =
        endDateMonth < 10 ? `0${endDateMonth}` : endDateMonth;

      const endDateWithLastDay = `${endDateYear}-${formattedMonth}-${lastDayOfMonth}`;

      console.log('startDateWithDay', startDateWithDay);
      console.log('this.startDate', this.startDate);

      this.dispatch_start_date = startDateWithDay;
      this.dispatch_end_date = endDateWithLastDay;

      this.getAll();
      this.getTasksCosts();
      this.getCashFlow();
    },
    padMonth(month) {
      return month.toString().padStart(2, '0');
    },
    getMonthNumber(monthName) {
      const months = [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
      ];
      return months.indexOf(monthName) + 1;
    },

    toggleDateFiltering() {
      this.useDateRangeInputs = !this.useDateRangeInputs;
    },

    applyDateFilter() {
      this.$toast.success('Filtrado por período.', {
        position: 'top-right',
        timeout: 5000,
        closeOnClick: true,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 0.6,
        showCloseButtonOnHover: false,
        hideProgressBar: true,
        closeButton: 'button',
        icon: true,
        rtl: false,
      });

      this.updateDates();
    },

    async setHoursPerEmployee_data(props) {
      this.originalHoursEmployeeProps = props;
      const data = [];
      const date = [];
      const member_ids = [];
      props.map((e) => {
        data.push(e.hour);
        date.push(e.username);
        member_ids.push(e.member_id);
      });
      //const customColors = this.generateHexColors(props.length);

      this.hoursPerEmployee_data = {
        render: date.length > 0,
        width: '100%',
        height: '300',
        chartOptions: {
          theme: {
            mode: this.appMode,
          },
          colors: [this.appMode === 'dark' ? '#00e396' : '#008FFB'],
          chart: {
            type: 'bar',
            events: {
              dataPointSelection: (event, chartContext, config) => {
                const dataIndex = config.dataPointIndex;
                const member_id = member_ids[dataIndex];
                if (member_id) {
                  this.$router.push(`/usuarios/dashboard/${member_id}`);
                }
              },
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: (val) => (val ? `${val}h` : '0h'),
            },
          },
          legend: {
            show: false,
          },
          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
              columnWidth: '30%',
              distributed: false,
              dataLabels: {
                position: 'top',
              },
            },
          },
          dataLabels: {
            enabled: true,
            offsetX: 25,
            formatter: (val) => {
              //const name = date[opts.dataPointIndex];
              return `${val}h`;
            },
            style: {
              fontSize: '11px',
              fontWeight: 'bold',
              colors: [this.appMode === 'dark' ? '#ffffff' : '#333333'],
            },
          },
          xaxis: {
            tickAmount: date.length > 5 ? 5 : date.length,
            categories: date,
            labels: {
              show: true,
              trim: false,
              style: {
                fontSize: '12px',
                fontWeight: 'bold',
              },
              formatter: (val) => `${val}h`,
            },
          },
        },
        chartSeries: [
          {
            name: 'Horas',
            data,
          },
        ],
      };
    },

    async setCashFlow_data(mode = this.appMode) {
      this.cashFlow_data = {
        render: true,
        width: '100%',
        height: 400,

        chartOptions: {
          theme: {
            mode: mode,
          },
          chart: {
            type: 'line',
            stacked: true,
          },
          xaxis: {
            categories: this.cashFlowResp.categories,
            labels: {
              formatter: function (value) {
                return moment(value, 'YYYY-MM').format('MMM YYYY'); // Exemplo: "Abr 2024"
              },
            },
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                let value = val / 100;
                return `R$ ${value.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`;
              },
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '60%',
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (val) {
                let value = val / 100;
                return `R$ ${value.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`;
              },
            },
          },
          colors: ['#28a745', '#dc3545', '#ffd147', '#6c757d'], // Adicionando cor para Outras Despesas
          stroke: {
            width: [0, 0, 0, 3], // Linha apenas para o saldo
          },
          markers: {
            size: [0, 0, 0, 5], // Marcador apenas no saldo
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              let value = val / 100;
              return `R$ ${value.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}`;
            },
          },
        },
        chartSeries: this.cashFlowResp.chartSeries,
      };
    },

    async setCostPerProject_data(props) {
      this.originalProjectCostProps = props;
      const data = [];
      const date = [];
      const project_ids = [];

      // const customColors = this.generateHexColors(props.length);

      props.forEach((e) => {
        data.push(e.project_cost + e.legalExpenses / 100);
        date.push(e.project_name);
        project_ids.push(e.project_id);
      });
      const baseHeight = 300;
      const extraHeight = 20;
      const calculatedHeight = baseHeight + data.length * extraHeight;

      this.costPerProject_data = {
        render: date.length > 0,
        width: '100%',
        height: Math.min(calculatedHeight, 800),

        chartOptions: {
          colors: [this.appMode === 'dark' ? '#00e396' : '#008FFB'],

          theme: {
            mode: this.appMode,
          },
          chart: {
            type: 'bar',
            events: {
              dataPointSelection: (event, chartContext, config) => {
                const dataIndex = config.dataPointIndex;
                const project_id = project_ids[dataIndex];

                if (project_id) {
                  this.$router.push(`/projetos/dashboard/${project_id}`);
                }
              },
            },
          },
          legend: {
            show: false, // Remove a legenda de cores desnecessária
          },
          plotOptions: {
            bar: {
              borderRadius: 6,
              horizontal: true,
              columnWidth: '30%',
              distributed: false,
              dataLabels: {
                position: 'top',
              },
            },
          },

          dataLabels: {
            enabled: true,
            offsetX: 80,
            formatter: function (val) {
              let value = val / 100;
              return `R$ ${value.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}`;
            },
            style: {
              fontWeight: 'regular',
              colors: [this.appMode === 'dark' ? '#ffffff' : '#333333'],
            },
          },
          xaxis: {
            categories: date,
            labels: {
              formatter: function (val) {
                const value = val / 100;
                return `R$ ${value.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`;
              },
            },
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return `${val.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`;
              },
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: function (val) {
                let value = val / 100;
                return `R$ ${value.toLocaleString('pt-BR', {
                  minimumFractionDigits: 2,
                })}`;
              },
            },
          },
        },
        chartSeries: [
          {
            name: 'Custo do Projeto',
            data,
          },
        ],
      };
    },

    async setcostPerOffice_data(props) {
      this.originalCostPerOfficeProps = props;

      const data = [];
      const date = [];

      props.map((e) => {
        data.push(e.totalCost);
        date.push(e.year);
      });

      this.costPerOffice_data = {
        render: date.length > 0,
        width: '100%',
        height: 300,
        chartOptions: {
          colors: [this.appMode === 'dark' ? '#00e396' : '#008FFB'],

          theme: {
            mode: this.appMode,
          },
          chart: {
            type: 'bar',
            events: {
              dataPointSelection: () => {
                this.$router.push('/lancamento-de-receita');
              },
            },
          },

          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
              columnWidth: '200px',
              distributed: true,
              dataLabels: {
                position: 'top',
              },
            },
          },
          dataLabels: {
            enabled: true,
            offsetX: 80,

            formatter: function (val) {
              let value = val / 100;

              return `R$ ${value.toLocaleString('pt-BR', {
                minimumFractionDigits: 2,
              })}`;
            },
            style: {
              fontWeight: 'regular',
              colors: [this.appMode === 'dark' ? '#ffffff' : '#333333'],
            },
          },
          yaxis: {
            categories: data,
          },
          xaxis: {
            tickAmount: 3,
            labels: {
              formatter: function (number) {
                if (isNaN(number)) {
                  return 'Invalid input';
                }
                if (number === 0) {
                  return 'R$ 0,00';
                }
                if (number < 100) {
                  const formattedCents = number.toFixed(2).padStart(5, '0');
                  return `0,${formattedCents}`;
                }
                const [integerPart, decimalPart] = (number / 100)
                  .toFixed(2)
                  .toString()
                  .split('.');
                const formattedIntegerPart = integerPart.replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  ',',
                );
                const result = ` ${formattedIntegerPart},${decimalPart}`;
                return result;
              },
            },
            categories: date,
          },
          tooltip: {
            x: { show: true },
            y: {
              formatter: function (number) {
                if (isNaN(number)) {
                  return 'Invalid input';
                }
                if (number === 0) {
                  return 'R$ 0,00';
                }
                if (number < 100) {
                  const formattedCents = number.toFixed(2).padStart(5, '0');
                  return `0,${formattedCents}`;
                }
                const [integerPart, decimalPart] = (number / 100)
                  .toFixed(2)
                  .toString()
                  .split('.');
                const formattedIntegerPart = integerPart.replace(
                  /\B(?=(\d{3})+(?!\d))/g,
                  ',',
                );
                const result = ` ${formattedIntegerPart},${decimalPart}`;
                return result;
              },
            },
          },
        },
        chartSeries: [
          {
            name: 'Custo',
            data,
          },
        ],
      };
    },
    groupDataByDateAndUser_cost(data) {
      const groupedData = {};

      data.forEach((item) => {
        if (!groupedData[item.username]) {
          groupedData[item.username] = {
            direct_cost: 0,
            indirect_cost: 0,
          };
        }

        groupedData[item.username].direct_cost += Number(item.direct_cost) || 0;

        groupedData[item.username].indirect_cost +=
          Number(item.indirect_cost) || 0;
      });

      return groupedData;
    },

    async setCostPerMemberChart(value) {
      this.hoursPerMember_dataProps = value;

      const groupedData = this.groupDataByDateAndUser_cost(
        this.hoursPerMember_dataProps,
      );

      const name = Object.keys(groupedData);

      const directCost = name.map(
        (username) => groupedData[username].direct_cost,
      );

      const indirectCost = name.map(
        (username) => groupedData[username].indirect_cost,
      );

      this.costsPerMember_data = {
        render: name.length > 0,

        chartOptions: {
          chart: {
            type: 'bar',
          },

          plotOptions: {
            bar: {
              horizontal: true,
              dataLabels: {
                position: 'top',
              },
            },
          },

          dataLabels: {
            enabled: true,

            formatter: (val) => `R$ ${this.numberToMonetary(val)}`,

            style: {
              colors: [this.appMode === 'dark' ? '#ffffff' : '#333333'],
              fontSize: '12px',
            },

            offsetX: 10,
            offsetY: 0,
          },

          tooltip: {
            x: {
              show: true,
            },

            y: {
              formatter: function (number) {
                if (isNaN(number)) {
                  return 'Invalid input';
                }

                if (number === 0) {
                  return 'R$ 0,00';
                }

                const val = number / 100;

                return val.toLocaleString('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                });
              },
            },
          },

          xaxis: {
            categories: name,

            labels: {
              formatter: (val) => `${this.currencyFormatter(val / 100)}`,

              style: {
                colors: [this.appMode === 'dark' ? '#ffffff' : '#333333'],
                fontSize: '12px',
              },
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: [this.appMode === 'dark' ? '#ffffff' : '#000'],
                fontSize: '12px',
              },
            },
          },
        },

        chartSeries: [
          {
            name: 'Custo Direto',
            data: directCost,
          },
          {
            name: 'Custo Indireto',
            data: indirectCost,
          },
        ],
      };
    },

    openModalAction() {
      this.myTasksModal = true;
    },
    closeModal() {
      this.myTasksModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.cta {
  width: 100%;
  margin-bottom: 10px;
}
.infos {
  display: flex;
  flex-direction: column;
}
.dashboard-item {
  margin-bottom: 15px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  /* border: 1px solid #ddd; */
  border-radius: 5px;
  text-align: start;
  width: 200px;
}

.overflow-scroll-mobile {
  overflow-x: auto;
  white-space: wrap;
}
.finance-card {
  position: relative;
  border-radius: 0.75rem;
  padding: 1.5rem 1.5rem 1.25rem;
  color: #ffffff;
  overflow: hidden;
  box-shadow: 0 4px 18px -6px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: default;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 24px -8px rgba(0, 0, 0, 0.35);
  }

  &--revenue {
    background: linear-gradient(135deg, #34d399 0%, #059669 100%);
  }

  &--expense {
    background: linear-gradient(135deg, #f87171 0%, #b91c1c 100%);
  }

  &__badge {
    position: absolute;
    top: 1.1rem;
    right: 1.1rem;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__badge-trend {
    position: absolute;
    bottom: -4px;
    right: -4px;
    background: #ffffff;
    border-radius: 50%;
    padding: 2px;
  }
  &--revenue .finance-card__badge-trend {
    color: #059669;
  }
  &--expense .finance-card__badge-trend {
    color: #b91c1c;
  }

  &__title {
    display: block;
    font-size: 1rem;
    font-weight: 600;
    margin-bottom: 1.1rem;
    opacity: 0.95;
  }

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    padding: 0.4rem 0;
    font-size: 0.85rem;
    opacity: 0.9;
  }

  &__row--total {
    margin-top: 0.5rem;
    padding-top: 0.75rem;
    border-top: 1px solid rgba(255, 255, 255, 0.35);
    opacity: 1;
  }

  &__row--total &__label,
  &__row--total &__value {
    font-size: 1.15rem;
    font-weight: 700;
  }

  &__label {
    font-weight: 400;
  }

  &__value {
    font-weight: 600;
    letter-spacing: 0.2px;
  }
}
</style>
